import React, { Component } from 'react';
import JsonapiClient from '@holidayextras/jsonapi-client';
import { authService } from '../../../utils/auth-service';

const withTrackedAssetsData = WrapperComponent => class HasTrackedAssetsData extends Component {
  constructor(props) {
    super(props);
    this.jsonAPIClient = new JsonapiClient(process.env.REACT_APP_API_BASE_URL, {
      header: {
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });
  }

  createTrackedAsset = async ({
    assetId,
    assetURL,
    discussionId,
    campaignId,
    discussionName,
    instagramAccountId,
    platform,
    assetType,
  }) => {
    const trackedAsset = this.jsonAPIClient.create('trackedAssets');
    trackedAsset.set('assetId', assetId);
    trackedAsset.set('assetURL', assetURL);
    trackedAsset.set('user', {
      type: 'users',
      id: authService.uid(),
    });
    trackedAsset.set('campaign', {
      type: 'campaigns',
      id: campaignId,
    });
    trackedAsset.set('discussion', {
      type: 'discussions',
      id: discussionId,
    });
    trackedAsset.set('discussionName', discussionName);
    if (platform === 'INSTAGRAM') trackedAsset.set('instagramAccountId', instagramAccountId);
    trackedAsset.set('platform', platform);
    trackedAsset.set('assetType', assetType);
    trackedAsset.set('createdSource', 'CAMPAIGN');
    return trackedAsset.sync().then(response => response.toJSON());
  };

  syncTrackedAssetAndDiscussion = async ({ discussionId, trackedAssetId }) => {
    const discussion = await this.jsonAPIClient.get('discussions', discussionId);
    const trackedAsset = await this.jsonAPIClient.get('trackedAssets', trackedAssetId);
    discussion.set('hasPosted', true);
    return discussion.relationships('trackedAssets').add(trackedAsset).sync();
  }

  removeTrackedAssetById = async trackedAssetId => this.jsonAPIClient.get('trackedAssets', trackedAssetId).then(resource => resource.delete())

  removeTrackedAssetFromDiscussionById = async ({
    discussionId,
    trackedAssetId,
  }) => {
    const discussion = await this.jsonAPIClient.get('discussions', discussionId);
    const trackedAsset = await this.jsonAPIClient.get('trackedAssets', trackedAssetId);
    return discussion.relationships('trackedAssets').remove(trackedAsset).sync();
  }

  render() {
    return (
      <WrapperComponent
        {...this.props}
        removeTrackedAssetFromDiscussionById={this.removeTrackedAssetFromDiscussionById}
        createTrackedAsset={this.createTrackedAsset}
        syncTrackedAssetAndDiscussion={this.syncTrackedAssetAndDiscussion}
        removeTrackedAssetById={this.removeTrackedAssetById}
      />
    );
  }
};

export default withTrackedAssetsData;



/** WEBPACK FOOTER **
 ** ./src/hocs/data/with-tracked-assets-data/index.js
 **/